import {useState} from 'react'
import {fromMaybe} from '@freckle/maybe'
import {toggleMembership} from '@freckle/educator-entities/ts/common/helpers/common-helper'
import type {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'
import AddAssessmentModal from '@freckle/school/ts/pages/assessments/components/add-assessment-modal/add-assessment-modal'
import {getAccessibleGrades} from '@freckle/school/ts/pages/assessments/components/add-assessment-modal/utils'

type Props = {
  show: boolean
  onHide: () => void
  students: Array<StudentAttrs>
  onSubmit: (selectedStudentIds: Array<number>) => void
}

export function AddAssessmentModalContainer(props: Props) {
  const {students, show, onHide, onSubmit: onSubmitFromProps} = props

  const accessibleGrades = getAccessibleGrades(students)
  const initSelectedGrade = fromMaybe(() => 0, accessibleGrades[0])

  const [selectedGrade, setSelectedGrade] = useState<number>(initSelectedGrade)
  const [selectedStudentIds, setSelectedStudentIds] = useState<number[]>([])

  return (
    <AddAssessmentModal
      show={show}
      onHide={onHide}
      students={students}
      accessibleGrades={accessibleGrades}
      selectedGrade={selectedGrade}
      selectedStudentIds={selectedStudentIds}
      onChangeGrade={g => {
        setSelectedGrade(g)
        setSelectedStudentIds([])
      }}
      onToggleStudent={s => {
        setSelectedStudentIds(prev => toggleMembership(s, prev))
      }}
      onClickSelectAll={() => {
        const newSelectedStudentIds = students
          .filter(student => student.grade === selectedGrade)
          .map(student => student.id)
        setSelectedStudentIds(newSelectedStudentIds)
      }}
      onClickDeselectAll={() => {
        setSelectedStudentIds([])
      }}
      onSubmit={() => {
        onSubmitFromProps(selectedStudentIds)
      }}
    />
  )
}
